// extracted by mini-css-extract-plugin
export default {"card":"Dashboard_card__s-91e","courseName":"Dashboard_courseName__r-vJt"};